import { atom } from 'recoil';


export const googleReviewRatingState = atom<string | null>({
  key: 'googleReviewRatingState',
  default: null
});
